import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import ImageTab1 from 'assets/illustrations/kitdigital/tab-checkin.svg'
import ImageTab2 from 'assets/illustrations/kitdigital/tab-maintenance.svg'
import ImageTab3 from 'assets/illustrations/kitdigital/tab-cae.svg'
import ImageTab4 from 'assets/illustrations/kitdigital/tab-homologation.svg'
import ImageTabBottom1 from 'assets/illustrations/kitdigital/logo-price-cae.svg'
import ImageTabBottom2 from 'assets/illustrations/kitdigital/logo-price-homologation.svg'
import useStyles from './styles'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Tooltip from 'ui/components/tooltip'

import { withStyles } from '@material-ui/core/styles'
function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const LandingTabs = () => {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'))

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const TabTooltip = withStyles({
    tooltip: {
      top: theme.spacing(2),
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.dark,
    },
    arrow: {
      color: theme.palette.secondary.light,
    },
  })(Tooltip)

  return (
    <div className={classes.root}>
      <Tabs
        centered={!isSmall}
        variant={isSmall ? 'scrollable' : 'standard'}
        className={classes.tabs}
        value={value}
        onChange={handleChange}
        aria-label="Langing tabs"
        classes={{
          indicator: classes.indicator,
        }}
      >
        <TabTooltip title="Registro horario" arrow placement="top">
          <Tab
            className={classes.tab}
            label="🕒 Jornada laboral"
            disableRipple
            {...a11yProps(0)}
          />
        </TabTooltip>
        <TabTooltip title="mantenimiento" arrow placement="top">
          <Tab
            className={classes.tab}
            label="🧰 Mantenimiento"
            disableRipple
            {...a11yProps(1)}
          />
        </TabTooltip>
        <TabTooltip
          title="Coordinación de actividades empresariales"
          arrow
          placement="top"
        >
          <Tab
            className={classes.tab}
            label="👷🏻 CAE"
            disableRipple
            {...a11yProps(2)}
          />
        </TabTooltip>
        <TabTooltip title="Homologación de proveedores" arrow placement="top">
          <Tab
            className={classes.tab}
            label="🏆 Homologación"
            disableRipple
            {...a11yProps(2)}
          />
        </TabTooltip>
      </Tabs>
      <TabPanel value={value} index={0}>
        <Grid container spacing={4} className={classes.tabPanelContainer}>
          <Grid item xs={12} md={6} className={classes.tabPanelContentImage}>
            <img
              style={{ width: '100%' }}
              src={ImageTab1}
              alt="Jornada laboral"
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.tabPanelContentText}>
            <Typography variant="h1" className={classes.tabPanelContentTitle}>
              Cumple con la normativa
            </Typography>
            <Typography
              variant="body1"
              className={classes.tabPanelContentMainDescription}
            >
              Automatiza el registro horario de tus empleados y cumple con la
              normativa vigente.
            </Typography>
            <Grid item md={8}>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  🤖
                </span>{' '}
                Lectura automática
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Sistema de lectura automática con carné QR o DNI.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  🕰️
                </span>{' '}
                Registro
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Tus empleados se registran desde cualquier lugar.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  📑
                </span>{' '}
                Informes
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Descarga los informes de actividad.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  📍
                </span>{' '}
                Localización
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Gracias al control de presencia estarán siempre localizados.
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={10} md={7} className={classes.tabPanelContentPrice}>
            <img
              className={classes.tabPanelPriceImage}
              style={{ maxHeight: '150px' }}
              src={ImageTabBottom1}
              alt="Jornada laboral"
            />
            <Box className={classes.tabPanelPrice}>
              <Grid item xs={12} md={6}>
                <Typography variant="h2" className={classes.tabPanelPriceText}>
                  Desde{' '}
                  <span className={classes.textDark}>
                    <span role="img" aria-label="">
                      ⇥
                    </span>{' '}
                    0€
                  </span>{' '}
                  /mes.
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button
                  variant="contained"
                  className={classes.tabPanelPriceButton}
                  href="https://josdokify.typeform.com/to/vnFGsu6K"
                  target="_blank"
                >
                  Contáctanos
                </Button>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid container spacing={4} className={classes.tabPanelContainer}>
          <Grid
            item
            xs={12}
            md={6}
            className={clsx(
              classes.tabPanelContent,
              classes.tabPanelContentImage,
            )}
          >
            <img
              style={{ width: '100%' }}
              src={ImageTab2}
              alt="Mantenimiento"
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.tabPanelContent}>
            <Typography variant="h1" className={classes.tabPanelContentTitle}>
              Digitaliza tu gestión
            </Typography>
            <Typography
              variant="body1"
              className={classes.tabPanelContentMainDescription}
            >
              Gestiona de manera eficiente los mantenimientos de tus centros de
              trabajo.
            </Typography>
            <Grid item md={8}>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  🗓️
                </span>{' '}
                Planificación
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Planifica los mantenimientos a realizar.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  📬
                </span>{' '}
                Notificación
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Notifícalo a las empresas por email o vía app.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  📓
                </span>{' '}
                Histórico
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Consulta el repositorio por centro o servicio.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  👽
                </span>{' '}
                Identidad
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Comprueba la identidad del trabajador que lo realiza.
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={10} md={7} className={classes.tabPanelContentPrice}>
            <img
              className={classes.tabPanelPriceImage}
              style={{ maxHeight: '150px' }}
              src={ImageTabBottom1}
              alt="Mantenimiento"
            />
            <Box className={classes.tabPanelPrice}>
              <Grid item xs={12} md={6}>
                <Typography variant="h2" className={classes.tabPanelPriceText}>
                  Desde{' '}
                  <span className={classes.textDark}>
                    <span role="img" aria-label="">
                      ⇥
                    </span>{' '}
                    408,87€
                  </span>{' '}
                  /año.
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button
                  variant="contained"
                  className={classes.tabPanelPriceButton}
                  href="https://josdokify.typeform.com/to/vnFGsu6K"
                  target="_blank"
                >
                  Contáctanos
                </Button>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Grid container spacing={4} className={classes.tabPanelContainer}>
          <Grid
            item
            xs={12}
            md={6}
            className={clsx(
              classes.tabPanelContent,
              classes.tabPanelContentImage,
            )}
          >
            <img style={{ width: '100%' }} src={ImageTab3} alt="CAE" />
          </Grid>
          <Grid item xs={12} md={6} className={classes.tabPanelContent}>
            <Typography variant="h1" className={classes.tabPanelContentTitle}>
              Garantiza la seguridad en tus centros
            </Typography>
            <Typography
              variant="body1"
              className={classes.tabPanelContentMainDescription}
            >
              Gestiona de forma eficiente los requisitos que solicitas a las
              contratas gracias a nuestra plataforma CAE.
            </Typography>
            <Grid item md={8}>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  🌍
                </span>{' '}
                Centralización
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Todas tus contratas registradas en un solo lugar.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  📑
                </span>{' '}
                Recopilación
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Recopila automáticamente toda su documentación.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  🔍
                </span>{' '}
                Revisión
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Dokify se encarga de su revisión.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  🚪
                </span>{' '}
                Acceso
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Controla quién puede acceder a tus centros.
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={10} md={7} className={classes.tabPanelContentPrice}>
            <img
              className={classes.tabPanelPriceImage}
              style={{ maxHeight: '150px' }}
              src={ImageTabBottom1}
              alt="CAE"
            />
            <Box className={classes.tabPanelPrice}>
              <Grid item xs={12} md={6}>
                <Typography variant="h2" className={classes.tabPanelPriceText}>
                  Desde{' '}
                  <span className={classes.textDark}>
                    <span role="img" aria-label="">
                      ⇥
                    </span>{' '}
                    408,87€
                  </span>{' '}
                  /año.
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button
                  variant="contained"
                  className={classes.tabPanelPriceButton}
                  href="https://josdokify.typeform.com/to/AvrdeJ7M"
                  target="_blank"
                >
                  Contáctanos
                </Button>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Grid container spacing={4} className={classes.tabPanelContainer}>
          <Grid
            item
            xs={12}
            md={6}
            className={clsx(
              classes.tabPanelContent,
              classes.tabPanelContentImage,
            )}
          >
            <img style={{ width: '100%' }} src={ImageTab4} alt="Homologación" />
          </Grid>
          <Grid item xs={12} md={6} className={classes.tabPanelContent}>
            <Typography variant="h1" className={classes.tabPanelContentTitle}>
              Optimiza tu red de proveedores
            </Typography>
            <Typography
              variant="body1"
              className={classes.tabPanelContentMainDescription}
            >
              Automatiza la gestión de tus proveedores gracias a nuestro
              exclusivo estándar de homologación.
            </Typography>
            <Grid item md={8}>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  🗃️
                </span>{' '}
                Organización
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Controla y clasifícalos por categorías.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  🔒
                </span>{' '}
                Seguridad
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Otorga seguridad a tu departamento de compras.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  🤖
                </span>{' '}
                Automatización
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Automatiza el flujo de la gestión documental.
              </Typography>
              <Typography
                variant="h2"
                className={classes.tabPanelContentSubtitle}
              >
                <span role="img" aria-label="">
                  💼{' '}
                </span>{' '}
                Red de empresas
              </Typography>
              <Typography
                variant="body1"
                className={classes.tabPanelContentDescription}
              >
                Accede a la red de proveedores de dokify.
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={10} md={7} className={classes.tabPanelContentPrice}>
            <img
              className={classes.tabPanelPriceImage}
              style={{ maxHeight: '150px' }}
              src={ImageTabBottom2}
              alt="Homologación"
            />
            <Box className={classes.tabPanelPrice}>
              <Grid item xs={12} md={6}>
                <Typography variant="h2" className={classes.tabPanelPriceText}>
                  Desde{' '}
                  <span className={classes.textDark}>
                    <span role="img" aria-label="">
                      ⇥
                    </span>{' '}
                    408,87€
                  </span>{' '}
                  /año.
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button
                  variant="contained"
                  className={classes.tabPanelPriceButton}
                  href="https://josdokify.typeform.com/to/w7LweOdh"
                  target="_blank"
                >
                  Contáctanos
                </Button>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </TabPanel>
    </div>
  )
}

export default LandingTabs
